import appearancePreviewUrl from './appearancePreviewComponent.html';

class AppearancePreviewController {
  constructor(Authentication, ShiftUtils) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftUtils });
    this.user = Authentication.user;
  }

  getLabel(data) {
    return data.map((item) => this.defaultsMap[item]).join(' • ');
  }
}

export default {
  bindings: {
    preferences: '<',
    activeTab: '<',
    defaultsMap: '<',
  },
  controller: AppearancePreviewController,
  controllerAs: 'ctrl',
  templateUrl: appearancePreviewUrl,
};
